import { messages } from '@/src/lib/onboarding/messages';

export function ErrorState({
  title = messages['error.default.title'],
  description,
  hint,
  requestId,
  retryHref,
  retryLabel = messages['error.default.retry'],
  onRetry,
}: {
  title?: string;
  description: string;
  hint?: string;
  requestId?: string;
  retryHref?: string;
  retryLabel?: string;
  onRetry?: () => void;
}) {
  const hasRetry = Boolean(retryHref) || Boolean(onRetry);
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="rounded-[var(--k-radius-lg)] border border-[var(--k-color-danger)]/20 bg-[var(--k-color-danger-soft)] px-6 py-5"
    >
      <div className="space-y-2">
        <h3 className="text-lg font-semibold text-[var(--k-color-danger)]">{title}</h3>
        <p className="text-sm text-[var(--k-color-text-primary)]">{description}</p>
        {hint ? (
          <p className="text-sm text-[var(--k-color-text-secondary)]">{hint}</p>
        ) : (
          <p className="text-sm text-[var(--k-color-text-secondary)]">
            {messages['error.default.hint']}
          </p>
        )}
        {requestId ? (
          <p className="text-xs text-[var(--k-color-text-secondary)]">{messages['error.default.requestId']}: {requestId}</p>
        ) : null}
        {hasRetry ? (
          retryHref ? (
            <a
              href={retryHref}
              className="inline-flex items-center rounded-[var(--k-radius-md)] border border-[var(--k-color-danger)]/30 px-3 py-2 text-sm font-medium text-[var(--k-color-danger)] transition hover:bg-[var(--k-color-danger)]/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--k-color-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--k-color-surface)]"
            >
              {retryLabel}
            </a>
          ) : (
            <button
              type="button"
              onClick={onRetry}
              className="inline-flex items-center rounded-[var(--k-radius-md)] border border-[var(--k-color-danger)]/30 px-3 py-2 text-sm font-medium text-[var(--k-color-danger)] transition hover:bg-[var(--k-color-danger)]/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--k-color-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--k-color-surface)]"
            >
              {retryLabel}
            </button>
          )
        ) : null}
      </div>
    </div>
  );
}